import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * PropertyValuationUnit Widget
 */
@Component({
  selector: 'property-valuation-unit-widget',
  templateUrl: './property-valuation-unit-widget.component.html',
  styleUrls: ['./property-valuation-unit-widget.component.scss']
})
export class PropertyValuationUnitWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'valuationUnit', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadEmpty();

    this.widgetData$ = this.mockup ?
      this.widgetService.loadMockupData('assets/data/polluxMocks.widget-property-valuation-unit.json').pipe()
      : this.widgetService.load('valuationUnit', this.getReport()).pipe();
  }
}
